import RelateRecordDropdown from './RelateRecordDropdown';

export default RelateRecordDropdown;
